import { URL } from 'constants/api';
import { flattenDeep, values, get as getLoadsh } from 'lodash';
import { milisecond } from 'utils/time';
import {
  ALREADY_EXISTING,
  CLZ_UPDATE_STEP,
  NEW_BOD_UPDATE_OFFERS,
  NEW_BOD_UPDATE_USER_INFORMATION,
  NEW_BOD_UPDATE_USER_TOKEN,
  NEW_BOD_UPDATE_VERIFICATION_ID,
  PARTIAL_DEDUPLICATION,
  NEW_BOD_UPDATE_SCORING_TOKEN,
  OFFERS_FOUND,
  RECAL_STATUS_APPROVED,
  NEW_BOD_UPDATE_OFFER_TENORS,
  NEW_BOD_LOADING,
  UPDATE_BOD_APPLICATION_ID,
  PRE_APPROVED,
  REJECTED,
  CANCELLED,
  NO_OFFERS_CREATED,
  NEW_BOD_UPDATE_SA_CODE,
  NEW_BOD_UTM_LINK,
  PARTIAL_DEDUPLICATION_OUT_TIME,
} from 'constants/clz';
import { OFFERS_TYPE } from 'constants/prescore';
import { MESSAGE } from 'constants/internal';
import { getUserStatistics } from 'api/helpers';
import { getDeviceId } from 'utils/browser';
import { pushHashedCuid } from 'utils/ga';
import {
  STEPS,
  STEP_NAME,
  TIME_RECAL_API,
  TIME_WAITING,
} from 'routes/clz/0bod/constant';
import { post, get } from 'utils/http';
import CredoUtils from 'utils/credo';
import { HTTP_STATUS } from 'constants/http';

import { WAITING_TIMEOUT } from 'routes/clz/0bod/WaitingPage/constant';
import history from '../../history';
import { maintainAlert, alert } from '../alert';
import {
  sleep,
  getOffersScoring,
  getProOffer,
  getBestOfferForExitCustomer,
  getBestOffers,
} from './ultil';

const avaliableOfferType = [OFFERS_TYPE.CLX, OFFERS_TYPE.ACLX];

export function bodUtmLinkInfo(info) {
  return {
    type: NEW_BOD_UTM_LINK,
    payload: info,
  };
}

export function updateBODStep(step) {
  return {
    type: CLZ_UPDATE_STEP,
    payload: step,
  };
}

export function updateSACode(sa) {
  return {
    type: NEW_BOD_UPDATE_SA_CODE,
    payload: sa,
  };
}

export const updateUserInformation = info => ({
  type: NEW_BOD_UPDATE_USER_INFORMATION,
  payload: info,
});

export const updateOfferTenors = tenor => ({
  type: NEW_BOD_UPDATE_OFFER_TENORS,
  payload: tenor,
});

export const updateUserToken = token => ({
  type: NEW_BOD_UPDATE_USER_TOKEN,
  payload: token,
});
export const updateScoringToken = token => ({
  type: NEW_BOD_UPDATE_SCORING_TOKEN,
  payload: token,
});
export const updateVerificationID = verificationID => ({
  type: NEW_BOD_UPDATE_VERIFICATION_ID,
  payload: verificationID,
});
export const updateOffers = payload => ({
  type: NEW_BOD_UPDATE_OFFERS,
  payload,
});
export const updateBodLoading = payload => ({
  type: NEW_BOD_LOADING,
  payload,
});
export const updateApplicationId = id => ({
  type: UPDATE_BOD_APPLICATION_ID,
  id,
});
/**
 * @function verifyOtp
 * @param  {object} body { verificationID: string, phoneNumber: string, codeID: string, identificationNumber: string }
 * @param  {string} token       google recapcha token
 * @return {Promise}
 */
export const verifyOtp = (body, token) =>
  post(URL.BOD_VERIFY_OTP, body, token)
    .then(response => response.json())
    .catch(error => console.error('Error:', error));

export const updateRoute = (dispatch, step) => {
  dispatch(updateBODStep(step));
  return history.push(`/${STEP_NAME[step]}`);
};

export const getUserStatistic = async () => {
  const { tongdun } = window;
  const sessionID = document.getElementById('sessionID').getAttribute('value');

  const data = { tongdun };

  const deviceId = await getDeviceId();

  return [
    {
      key: 'session_id',
      value: sessionID,
    },
    {
      key: 'deviceid',
      value: deviceId || '0000',
    },
    ...getUserStatistics(data),
  ];
};

export const showErrorNotification = (message, noResetStep) => dispatch => {
  dispatch(
    alert({
      title: 'Thông báo',
      message,
      onClose: () => !noResetStep && updateRoute(dispatch, STEPS.START_LOAN),
    }),
  );
};
/**
 * @function getScoringOffer
 * @param  {string} scoringCode
 * @param  {string} token
 * @param  {number} startTime
 * @param  {func} dispatch redux dispatch function
 * @return {object || null}
 */
const getScoringOffer = async (scoringCode, token, startTime, dispatch) => {
  const time = new Date().getTime();
  if (time - startTime >= milisecond * WAITING_TIMEOUT) {
    return null;
  }
  const res = await get(
    `${URL.GET_RECAL_OFFER}/${scoringCode}?time=${time}`,
    token,
  );
  const { recalculateResult, offers } = await res.json();
  if (recalculateResult === RECAL_STATUS_APPROVED) {
    return offers;
  }
  if (recalculateResult === NO_OFFERS_CREATED) {
    return null;
  }
  await sleep(TIME_RECAL_API);
  return getScoringOffer(scoringCode, token, startTime, dispatch);
};
/**
 * @function recallOffers
 * @param  {object} body
 * @param  {string} token
 * @param  {func} dispatch redux dispatch function
 * @return {func || null}
 */
const recallOffers = async (body, token, dispatch) => {
  const time = new Date().getTime();

  const userStatistics = await getUserStatistic();
  await CredoUtils.collectAsync();
  CredoUtils.currentUUID &&
    userStatistics.push({
      key: 'iOvation_recordNumber',
      value: CredoUtils.currentUUID,
    });
  const response = await post(
    URL.RECAL_OFFER,
    { userStatistics, ...body },
    token,
  );

  const { scoringCode } = await response.json();

  if (scoringCode) {
    return getScoringOffer(scoringCode, token, time, dispatch);
  }
  return null;
};
/**
 * @function scoringOffersFlow
 * @param  {array} offers
 * @param  {number} income
 * @param  {string} userToken
 * @param  {func} dispatch redux dispatch function
 * @return {array}
 */
const scoringOffersFlow = async (
  offers,
  income,
  userToken,
  dispatch,
  employeeCode,
) => {
  let scoringOffers = getOffersScoring(offers);
  const productOffers = getProOffer(offers);
  if (scoringOffers && scoringOffers.length) {
    scoringOffers = await Promise.all(
      scoringOffers.map(async ({ offerId }) => {
        const scoringOffer = await recallOffers(
          {
            offerId,
            income,
            employeeCode,
          },
          userToken,
          dispatch,
        );
        return scoringOffer;
      }),
    );
  }
  const scoringSuccess = scoringOffers.every(item => !!item);
  const newOffers = flattenDeep(
    scoringSuccess ? [...productOffers, ...scoringOffers] : productOffers,
  );
  return newOffers || [];
};
/**
 * @function exitCustomerOffers
 * @param  {func} dispatch redux dispatch function
 * @param  {array} offers
 * @param  {number} income
 * @param  {string} userToken
 * @return {func} redux function
 */
export const exitCustomerOffers = (offers, userToken) => async (
  dispatch,
  getState,
) => {
  const {
    newBOD: {
      user: { income, homeId },
    },
  } = getState().clz;
  const offersData = await scoringOffersFlow(
    offers,
    income,
    userToken,
    dispatch,
    homeId,
  );

  const readyData = offersData.length && offersData.every(item => !!item);

  if (readyData) {
    const data = getBestOfferForExitCustomer(offersData, avaliableOfferType);
    if (data.length) {
      dispatch(updateOffers(data));
      return history.push(STEP_NAME.USER_HAS_OFFER);
    }
    return updateRoute(dispatch, STEPS.NO_OFFER);
  }
  return updateRoute(dispatch, STEPS.NO_OFFER);
};

/**
 * @function calculateBestOffer
 * @param  {object} offers offers after recall
 * @return {object} find out best offer
 */
export const calculateBestOffer = offers => {
  const readyData = offers?.length && offers.every(item => !!item);

  if (!readyData) return undefined;

  return getBestOffers(offers);
};

/**
 * @function updateCustomerOffers
 * @param  {func} dispatch redux dispatch function
 * @param  {object} offers offers after recall
 * @return {func} redux function
 */
export const updateCustomerOffers = async (dispatch, offers) => {
  const bestOffer = calculateBestOffer(offers);
  if (bestOffer) {
    dispatch(updateOffers([bestOffer]));
    return history.push(STEP_NAME.NEW_USER_HAS_OFFER);
  }

  return updateRoute(dispatch, STEPS.NO_OFFER);
};

/**
 * @function newCustomerOffers
 * @param  {func} dispatch redux dispatch function
 * @param  {string} cuid
 * @param  {number} income
 * @param  {string} userToken
 * @return {func} redux function
 */
export const newCustomerOffers = userToken => async (dispatch, getState) => {
  const {
    newBOD: {
      user: { income, cuid, homeId },
    },
  } = getState().clz;
  const offers = await recallOffers(
    {
      externalClientId: cuid,
      income,
      employeeCode: homeId,
      sourceChannel: 'WEB',
    },
    userToken,
    dispatch,
  );

  return updateCustomerOffers(dispatch, offers);
};

// exit customer no offer
export const scoringExitCustomerOffer = userToken => async (
  dispatch,
  getState,
) => {
  const {
    newBOD: {
      user: { income, cuid, homeId },
    },
  } = getState().clz;
  const offers = await recallOffers(
    {
      externalClientId: cuid,
      income,
      employeeCode: homeId,
      sourceChannel: 'WEB',
    },
    userToken,
    dispatch,
  );

  const data = getBestOfferForExitCustomer(offers, avaliableOfferType);
  if (data.length) {
    dispatch(updateOffers(data));
    return history.push(STEP_NAME.USER_HAS_OFFER);
  }

  return updateRoute(dispatch, STEPS.NO_OFFER);
};

/**
 * @function getOffers
 * @param  {string} userToken
 * @param  {boolean} isNewCustomer
 * @return {object}
 */
export const getOffers = (userToken, isNewCustomer) => async dispatch => {
  try {
    if (isNewCustomer) {
      return dispatch(newCustomerOffers(userToken));
    }
    const response = await get(URL.BOD_GET_OFFERS, userToken);
    const offers = await response.json();
    if (!offers) {
      return updateRoute(dispatch, STEPS.NO_OFFER);
    }
    if (offers.existingOffer !== OFFERS_FOUND || !offers.data.length) {
      return dispatch(scoringExitCustomerOffer(userToken));
    }
    return dispatch(scoringExitCustomerOffer(userToken));
  } catch (error) {
    dispatch(showErrorNotification(MESSAGE.BOD_INTERNAL_ERROR));
    return Promise.reject(error);
  }
};

/**
 * @function generateUserToken
 * @param  {string} cuid
 * @param  {string} id
 * @param  {string} token
 * @return {string}
 */
export const generateUserToken = (cuid, id, token) => async dispatch => {
  try {
    const response = await post(
      URL.BOD_GENERATE_TOKEN,
      { cuid, userId: id },
      token,
    );
    const { token: userToken } = await response.json();
    if (userToken) {
      dispatch(updateScoringToken(userToken));
    } else {
      dispatch(showErrorNotification(MESSAGE.INTERNAL_ERROR));
    }

    return userToken;
  } catch (e) {
    dispatch(showErrorNotification(MESSAGE.INTERNAL_ERROR));
    return Promise.reject(new Error('Error white generate user token'));
  }
};
/**
 * @function verifyNewCustomer
 * @param  {string} token
 * @param  {string} applicationId
 * @return {object}
 */
export const verifyNewCustomer = (
  token,
  applicationId,
  number = 0,
) => async dispatch => {
  try {
    const response = await get(
      `${
        URL.BOD_GET_NEW_CUSTOMER_INFO
      }/${applicationId}?time=${new Date().getTime()}`,
      token,
    );
    const data = await response.json();
    if (!data.status) {
      return dispatch(showErrorNotification(MESSAGE.INTERNAL_ERROR));
    }
    switch (data.status) {
      case PRE_APPROVED: {
        history.push(STEP_NAME.SUBMIT_APPLICATION_SUCCESS);
        return response;
      }
      case REJECTED: {
        dispatch(updateApplicationId());
        history.push(STEP_NAME.SUBMIT_APPLICATION_FAILED);
        return response;
      }
      case CANCELLED: {
        dispatch(updateApplicationId());
        history.push(STEP_NAME.SUBMIT_APPLICATION_REJECTED);
        return response;
      }
      default: {
        if (number * TIME_RECAL_API < TIME_WAITING) {
          await sleep(TIME_RECAL_API);
          await dispatch(verifyNewCustomer(token, applicationId, number + 1));
        } else {
          dispatch(showErrorNotification(MESSAGE.INTERNAL_ERROR));
        }
        return response;
      }
    }
  } catch (e) {
    dispatch(maintainAlert());
    return Promise.reject(new Error('Error white get application'));
  }
};
/**
 * @function additionDocument
 * @param  {object} payload
 * @param  {string} token
 * @return {object}
 */
export const additionDocument = (payload, token) => async dispatch => {
  try {
    const response = await post(URL.BOD_ADDITION_DOCUMENT, payload, token);
    const info = await response.json();
    if (response.status === HTTP_STATUS.OK) {
      dispatch(updateUserInformation(info));
      const nextStep = info?.saCode ? STEPS.NEW_USER_WAITING : STEPS.NO_SA_CODE;
      updateRoute(dispatch, nextStep);
      return response;
    }
    return dispatch(showErrorNotification(MESSAGE.INTERNAL_ERROR));
  } catch (e) {
    dispatch(showErrorNotification(MESSAGE.INTERNAL_ERROR));
    return Promise.reject(new Error('Error white add documents'));
  }
};
/**
 * @function createApplication
 * @param  {object} payload body payload
 * @param  {string} token  google recapcha token
 */
export const createApplication = (payload, token) => async dispatch => {
  try {
    dispatch(updateBodLoading(true));
    const response = await post(URL.BOD_CREATE_APPLICATION, payload, token);
    const { applicationCode } = await response.json();
    if (applicationCode) {
      dispatch(updateApplicationId(applicationCode));
      history.push(STEP_NAME.SUBMIT_APPLICATION_WAITING);
    } else {
      dispatch(showErrorNotification(MESSAGE.CREATE_APPLICATION_FAILED));
    }
    dispatch(updateBodLoading(false));
    return applicationCode;
  } catch (e) {
    dispatch(updateBodLoading(false));
    dispatch(maintainAlert());
    return Promise.reject(new Error('Error white Create application'));
  }
};
/**
 * @function generateOTP
 * @param  {string} phoneNumber primary phonenumber
 * @param  {string} token       google recapcha token
 * @return {string} verification customer id
 */
export const generateOTP = (phoneNumber, token) => async dispatch => {
  try {
    const response = await post(URL.BOD_GENERATE_OTP, { phoneNumber }, token);
    const { verificationID } = await response.json();
    if (verificationID) {
      dispatch(updateVerificationID(verificationID));
    } else {
      dispatch(showErrorNotification(MESSAGE.INTERNAL_ERROR));
    }
    return verificationID;
  } catch (e) {
    dispatch(maintainAlert());
    return Promise.reject(new Error('Error white generate OTP'));
  }
};

/**
 * @function getStepExistedNewAsync
 * @param  {object} info customer information
 * @param  {object} token object others
 * @return {enum} STEPS
 */
export const getStepExistedNewAsync = info => async (dispatch, getState) => {
  const {
    clz: {
      newBOD: { token: userToken },
    },
  } = getState();

  const { cuid, id } = info;

  const token = await dispatch(generateUserToken(cuid, id, userToken));
  const response = await get(URL.BOD_GET_OFFERS, token);
  const { existingOffer, data: offers } = await response.json();

  const bestOffer = calculateBestOffer(offers);

  if (existingOffer === OFFERS_FOUND && bestOffer) {
    dispatch(updateOffers([bestOffer]));
    return history.push(STEP_NAME.NEW_USER_HAS_OFFER);
  }

  return updateRoute(dispatch, STEPS.NEW_CUSTOMER_DOCS);
};

/**
 * @function customerStatusActions check response status to redirect and push hashedCUID into dataLayer
 * @param  {function} dispatch redux dispatch function
 * @param  {object} info     customer information
 * @param  {boolean} isRecall is recall get customer information
 * @return {object} customer information
 */
const customerStatusActions = async (dispatch, info, { isRecall } = {}) => {
  dispatch(updateUserInformation(info));
  if (info?.hashedCUID)
    pushHashedCuid('hashedCuid', info.hashedCUID);

  switch (info.result) {
    case PARTIAL_DEDUPLICATION: {
      if (!isRecall) {
        updateRoute(dispatch, STEPS.DEDUP_WAITING);
      }
      return info;
    }
    case PARTIAL_DEDUPLICATION_OUT_TIME: {
      updateRoute(dispatch, STEPS.DEDUP_WAITING_OUT_TIME);
      return info;
    }
    case ALREADY_EXISTING: {
      updateRoute(dispatch, STEPS.WAITING);
      return info;
    }
    default:
      updateRoute(dispatch, STEPS.NEW_CUSTOMER_DOCS);
      return info;
  }
};

/**
 * @function getCustomerOffer
 * @param  {number} amount
 * @param  {string} offerId
 * @param  {string} hasLifeInsurance
 * @return {array}
 */
export const getCustomerOffer = (amount, offerId, hasLifeInsurance) => async (
  dispatch,
  getState,
) => {
  dispatch(updateBodLoading(true));
  const {
    newBOD: {
      user: { token },
    },
  } = getState().clz;
  try {
    const response = await post(
      URL.GET_CUSTOMER_OFFER,
      {
        requestedLoanAmount: {
          amount,
          currency: 'VND',
        },
        campaignID: offerId,
        hasLifeInsurance,
      },
      token,
    );
    const { data } = await response.json();
    if (data) {
      const tenors = data.reduce(
        (result, { celOffer, offerCode, productInformation }) => {
          const currentItem = getLoadsh(result, celOffer.tenor);
          if (
            !currentItem ||
            currentItem.celOffer.annualInterestRate >
              celOffer.annualInterestRate
          ) {
            return {
              ...result,
              [celOffer.tenor]: {
                value: celOffer.tenor,
                label: `${celOffer.tenor} tháng`,
                offerCode,
                productCode: productInformation.code,
                celOffer,
              },
            };
          }
          return result;
        },
        {},
      );
      dispatch(updateOfferTenors(values(tenors)));
    } else {
      dispatch(updateOfferTenors([]));
    }
    dispatch(updateBodLoading(false));
    return data;
  } catch (err) {
    dispatch(updateBodLoading(false));
    dispatch(maintainAlert());
    return Promise.reject(err);
  }
};

/**
 * @function getCustomerInfoDedup
 * @param  {function} dispatch redux dispatch function
 * @param  {object} getState redux state
 * @return {object} customer information
 */
export const getCustomerInfoDedup = isRecall => async (dispatch, getState) => {
  const {
    newBOD: {
      user: { id },
      token,
    },
  } = getState().clz;
  try {
    const response = await get(`${URL.BOD_CUSTOMER_INFOR}/${id}`, token);
    const info = await response.json();
    return customerStatusActions(dispatch, info, { isRecall });
  } catch (error) {
    dispatch(maintainAlert());
    return Promise.reject(error);
  }
};

/**
 * @function identifyCustomer
 * @return {function} redux function to get user information
 */
export const identifyCustomer = () => async (dispatch, getState) => {
  const {
    newBOD: {
      user: {
        firstName,
        lastName,
        middleName,
        primaryPhone,
        genderCode,
        income,
        birthday,
        idNumber,
        homeId,
      },
      token,
      utm,
    },
  } = getState().clz;
  try {
    const body = {
      firstName,
      lastName,
      middleName,
      primaryPhone,
      genderCode,
      income: `${income}`,
      birthday,
      idNumber: `${idNumber}`,
      saCode: homeId,
      utm,
    };

    const response = await post(URL.BOD_IDENTIFY_CUSTOMER, body, token);
    const info = await response.json();
    if (response.status === HTTP_STATUS.OK)
      return customerStatusActions(dispatch, info, { token });
    return dispatch(showErrorNotification(MESSAGE.BOD_INTERNAL_ERROR));
  } catch (error) {
    dispatch(showErrorNotification(MESSAGE.BOD_INTERNAL_ERROR));
    return Promise.reject(error);
  }
};
